import { useState, useEffect, useContext } from "react";
import { fetchedWarehousesBySubsidiary } from "../../../apis/apis.logistics/apisProduct";
import { ContextAuth } from "../../../contexts/ContextAuth";

import { operationDocumentTypes } from "../../../configs/Data";

export function ReceiveOrderPurchaseForm({ order, setOrder }) {
    const { auth } = useContext(ContextAuth);
    const [warehouses, setWarehouses] = useState([]);
    const getWarehouses = async (id) => {
        try {
            const response = await fetchedWarehousesBySubsidiary({
                subsidiaryID: id,
            });
            setWarehouses(response);
        } catch (error) {
            throw error;
        }
    };
    useEffect(() => {
        getWarehouses(auth.data.subsidiary.subsidiary_id);
    }, []);

    const inputClass =
        "w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors";
    const labelClass =
        "block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-1";

    return (
        <div className="mb-6">
            <h5 className="text-sm font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wide mb-4">
                Datos de Operación
            </h5>
            <div className="border-t border-gray-200 dark:border-gray-700 mb-4"></div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
                <div className="lg:col-span-2">
                    <div className="flex flex-col md:flex-row gap-4">
                        {/** Tipo Documento */}
                        <div className="flex-1">
                            <label className={labelClass}>
                                Tipo Documento:
                            </label>
                            <select
                                className={inputClass}
                                name="operationDocumentTypeID"
                                onChange={(e) => {
                                    setOrder({
                                        ...order,
                                        operationDocumentTypeID: e.target.value,
                                    });
                                }}
                                value={order.operationDocumentTypeID}
                            >
                                {operationDocumentTypes.map((item, index) => {
                                    return (
                                        <option key={index} value={item.id}>
                                            {item.name}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                        {/** Número Documento */}
                        <div className="flex-1">
                            <label className={labelClass}>
                                Número Documento:
                            </label>
                            <input
                                type="text"
                                className={inputClass}
                                name="operationDocumentNumber"
                                placeholder="Ingrese texto"
                                onChange={(e) => {
                                    setOrder({
                                        ...order,
                                        [e.target.name]: e.target.value,
                                    });
                                }}
                                value={order.operationDocumentNumber}
                                autoComplete="off"
                                maxLength={15}
                            />
                        </div>
                    </div>
                </div>
                {/** Almacén */}
                <div className="flex-1">
                    <label className={labelClass}>Almacén:</label>
                    <select
                        className={inputClass}
                        name="warehouseID"
                        onChange={async (e) => {
                            const found = await warehouses.find(
                                function (warehouse, index) {
                                    if (warehouse.warehouseID == e.target.value)
                                        return true;
                                },
                            );
                            if (found) {
                                setOrder({
                                    ...order,
                                    warehouseID: found.warehouseID,
                                    warehouseName: found.warehouseName,
                                    warehouseCategory: found.warehouseCategory,
                                    userID: auth.data.user_id,
                                });
                            }
                        }}
                        value={order.warehouseID}
                    >
                        <option value="0">Elegir</option>
                        {warehouses.map((item, index) => {
                            return (
                                <option key={index} value={item.warehouseID}>
                                    {item.warehouseName}
                                </option>
                            );
                        })}
                    </select>
                </div>
                {/** Fecha de Recepción */}
                <div>
                    <label className={labelClass}>Fecha de Recepción:</label>
                    <input
                        type="date"
                        name="operationDate"
                        className={inputClass}
                        value={order.operationDate}
                        onChange={(e) => {
                            setOrder({
                                ...order,
                                [e.target.name]: e.target.value,
                            });
                        }}
                    />
                </div>
                <div>
                    <label className={labelClass}>Tipo de Compra</label>
                    <select
                        className={inputClass}
                        name="affectsStock"
                        value={order.affectsStock ? "true" : "false"}
                        onChange={(e) => {
                            setOrder({
                                ...order,
                                affectsStock: e.target.value === "true",
                            });
                        }}
                    >
                        <option value="true">
                            Compra física (Aumenta stock)
                        </option>
                        <option value="false">Compra (solo registro)</option>
                    </select>
                </div>
            </div>
        </div>
    );
}
